import React from "react";
import { Calendar } from "primereact/calendar";
import { Button } from "primereact/button";
import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
} from "@material-ui/core";

const DataRangePicker = (
	{
		visible,
		dateRange,
		handleClose,
		handleDateRange,
		handleGeneratePDF,
		handleGenerateExcel,
		resetDataRangeModel,
	}) => {

	return (
		<div>
			<Dialog
				open={visible}
				onClose={() => handleClose('CloseDateRangeModel')}
				aria-labelledby="date-range-dialog-title"
			>
				<DialogTitle
					id="date-range-dialog-title"
					className="custom-dialog-header"
				>
					<div>Select Date Range</div>
					<div
						className="dialog-close"
						onClick={() => handleClose("CloseDateRangeModel")}
					>
						<i className="icon-modal-close"></i>
					</div>
				</DialogTitle>
				<DialogContent className="CHA-dialog-content-area">
					<div className="p-fluid">
						<Calendar
							showIcon
							showTime
							showButtonBar
							readOnlyInput
							yearNavigator
							monthNavigator
							dateFormat="dd/mm/yy"
							hourFormat="12"
							className="w-full"
							selectionMode="range"
							yearRange="1969:2100"
							placeholder="Select Date Range"
							value={dateRange}
							onChange={(e) => handleDateRange(e.value)}
						/>
					</div>
				</DialogContent>
				<DialogActions className="p-p-0 dialog-footer1">
					<Button
						className="primary-btn1"
						onClick={resetDataRangeModel}
					>
						Reset
					</Button>
					<Button
						className="primary-btn"
						onClick={handleGeneratePDF}
					>
						Generate PDF
					</Button>
					<Button
						className="primary-btn"
						onClick={handleGenerateExcel}
					>
						Generate Excel
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	)
};

export default DataRangePicker;
